// Product configuration - just add to the array

export const categories = [
  {
    id: "security-tools",
    name: "Security Tools",
    description: "Security scanning and infrastructure assessment tools",
    icon: "shield",
  },
  {
    id: "workflows",
    name: "Workflows",
    description: "Automated workflow solutions and process optimization",
    icon: "cog",
  },
  {
    id: "compliance",
    name: "Compliance",
    description: "Regulatory compliance and standards verification",
    icon: "check-square",
  },
  {
    id: "automation",
    name: "Automation",
    description: "Process automation and integration tools",
    icon: "bolt",
  },
  {
    id: "ai-tools",
    name: "AI Tools",
    description: "Artificial intelligence and machine learning solutions",
    icon: "brain",
  },
];

export const products = [
  {
    id: 1,
    name: "nis2scan",
    slug: "nis2scan",
    path: "/products/nis2scan",
    delivery: "contact-sales",
    tagline: "NIS2 Article 21 Compliance Scanner",
    description:
      "Single binary. Zero dependencies. Scans all 9 NIS2 Article 21 controls in parallel and produces an auditor-ready PDF report in under 10 seconds.",
    status: "Available",
    category: "security-tools",
    featured: true,
    new: false,
    icon: "shield-alt",
    color: "#2563eb",
    license: "One-time purchase · Lifetime updates",
    tags: ["security", "scan", "infrastructure", "compliance", "NIS2"],
    badge: null,
    openSource: true,
    githubUrl: "https://github.com/AxiomLabsSolutions/nis2scan",
    platforms: ["Linux", "Windows"],
    pricing: [
      {
        tier: "Single Company",
        price: 999,
        currency: "EUR",
        description: "One installation, one network",
        delivery: "contact-sales",
      },
      {
        tier: "Consultant Pack",
        price: 2499,
        currency: "EUR",
        description: "Up to 10 client networks",
        delivery: "contact-sales",
        popular: true,
      },
      {
        tier: "MSP Pack",
        price: 4999,
        currency: "EUR",
        description: "Unlimited networks",
        delivery: "contact-sales",
      },
    ],
    sampleReports: [
      {
        label: "Sample Report — Windows Server",
        filename: "nis2scan-sample-windows.pdf",
        path: "/samples/nis2scan-sample-windows.pdf",
      },
      {
        label: "Sample Report — Linux Server",
        filename: "nis2scan-sample-linux.pdf",
        path: "/samples/nis2scan-sample-linux.pdf",
      },
    ],
    featuresTitle: "Built for Real Infrastructure",
    featuresSubtitle: "No bloat, no complexity. Just a single binary.",
    features: [
      {
        title: "Single Binary",
        text: "One file, zero dependencies. Download and run anywhere.",
      },
      {
        title: "Under 10 Seconds",
        text: "Full infrastructure scan completes in seconds.",
      },
      {
        title: "Detailed Reports",
        text: "Actionable findings with severity ratings and remediation steps.",
      },
      {
        title: "100% Offline",
        text: "No cloud, no telemetry, no data leaving your network.",
      },
      {
        title: "Your Infrastructure",
        text: "Runs on your systems. No third-party servers.",
      },
      {
        title: "One-Time Purchase",
        text: "Own it forever. No subscriptions, no renewals.",
      },
    ],
    checkoutFeatures: [
      "Full nis2scan binary",
      "Detailed PDF & JSON reports",
      "Lifetime updates",
      "Email support",
      "Runs offline, no cloud",
    ],
  },
  {
    id: 2,
    name: "phantom-vox",
    slug: "phantom-vox",
    path: "/products/phantom-vox",
    delivery: "auto",
    tagline: "Professional AI Voice Generator",
    description:
      "Turn any text into studio-quality audio in minutes. 28 voices, no subscriptions, no API keys. Powered by Kokoro TTS.",
    status: "Available",
    category: "ai-tools",
    featured: true,
    new: true,
    icon: "mic",
    color: "#8b5cf6",
    license: "One-time purchase · $9",
    tags: ["AI", "voice", "text-to-speech", "content creation", "audio"],
    badge: "28 Voices",
    priceEUR: 9,
    priceUSD: 10,
    featuresTitle: "Studio-Quality AI Voices",
    featuresSubtitle: "No cloud dependencies. No API keys. No subscriptions.",
    features: [
      {
        title: "28 Voices",
        text: "American and British accents, male and female.",
      },
      {
        title: "Zero Cost to Run",
        text: "Runs free on Google Colab. No API keys needed.",
      },
      {
        title: "Commercial Use",
        text: "Apache 2.0 license. Use for ads, YouTube, podcasts.",
      },
      {
        title: "Adjustable Speed",
        text: "From 0.8x tutorials to 1.2x fast ads.",
      },
      {
        title: "Simple Workflow",
        text: "Type text, pick a voice, click run. Download .wav.",
      },
      {
        title: "One-Time Purchase",
        text: "Pay once. Own the workflow forever.",
      },
    ],
    checkoutFeatures: [
      "Full PhantomVox notebook",
      "28 AI voices",
      "Commercial use license",
      "Lifetime updates",
    ],
  },
  {
    id: 3,
    name: "PhantomVision v1",
    slug: "phantom-vision",
    path: "/products/phantom-vision",
    delivery: "free",
    tagline: "Professional AI Image Generator",
    description:
      "Generate stunning dark fantasy concept art, cinematic portraits, warriors, creatures and environments — all for free on Google Colab. Powered by DreamShaper XL.",
    status: "Available",
    category: "ai-tools",
    featured: true,
    new: true,
    icon: "image",
    color: "#a855f7",
    license: "Free · Non-commercial use",
    tags: ["AI", "image generation", "concept art", "fantasy", "free"],
    badge: "Free",
    openSource: true,
    githubUrl: "https://github.com/axiomlabssolutions",
    priceEUR: 0,
    priceUSD: 0,
    downloadUrl: null,
    featuresTitle: "What It Creates",
    featuresSubtitle:
      "Dark fantasy, cinematic, and photorealistic — no design skills needed.",
    features: [
      {
        title: "Fantasy Warriors",
        text: "Armored knights, viking warriors, assassins, mages — dramatic lighting and cinematic compositions.",
      },
      {
        title: "Sci-Fi Characters",
        text: "Mech suits, soldiers, cyborgs, space explorers — concept art ready for production.",
      },
      {
        title: "Photorealistic Portraits",
        text: "Close-up men and women with dramatic lighting, sharp focus, and cinematic depth.",
      },
      {
        title: "Creatures & Beasts",
        text: "Dragons, wolves, mythical monsters — detailed concept art for games and film.",
      },
      {
        title: "Environments",
        text: "Dark forests, mountain landscapes, sci-fi cities, ancient ruins — atmospheric world-building.",
      },
      {
        title: "Free on Google Colab",
        text: "Runs entirely free on a T4 GPU. No subscriptions, no API keys, no design skills needed.",
      },
    ],
    checkoutFeatures: [
      "Full PhantomVision notebook",
      "DreamShaper XL engine",
      "Batch generation support",
      "Prompt engineering guide included",
      "Free forever on Google Colab",
      "Community support",
    ],
    sampleImages: [
      {
        src: "/assets/images/products/phantom-vision/assassin_character.png",
        alt: "Assassin Character",
      },
      {
        src: "/assets/images/products/phantom-vision/viking_warrior.png",
        alt: "Viking Warrior",
      },
      {
        src: "/assets/images/products/phantom-vision/warrior_knight.png",
        alt: "Warrior Knight",
      },
      {
        src: "/assets/images/products/phantom-vision/scifi_soldier.png",
        alt: "Sci-Fi Soldier",
      },
      {
        src: "/assets/images/products/phantom-vision/fantasy_dragon.png",
        alt: "Fantasy Dragon",
      },
      {
        src: "/assets/images/products/phantom-vision/dark_forest.png",
        alt: "Dark Forest",
      },
      {
        src: "/assets/images/products/phantom-vision/portrait_man.png",
        alt: "Portrait — Man",
      },
      {
        src: "/assets/images/products/phantom-vision/portrait_woman.png",
        alt: "Portrait — Woman",
      },
      {
        src: "/assets/images/products/phantom-vision/lemon_gangster.png",
        alt: "Lemon Gangster",
      },
      {
        src: "/assets/images/products/phantom-vision/tomato_boss.png",
        alt: "Tomato Boss",
      },
    ],
  },
  {
    id: 4,
    name: "AxiomLabs Universal AI Proxy",
    slug: "axiom-proxy",
    path: "/products/axiom-proxy",
    delivery: "free",
    tagline: "Universal AI Proxy — Optimized for NVIDIA NIM",
    description:
      "A lightweight Python proxy that bridges Zed editor (and any OpenAI-compatible tool) to free AI providers — works best with NVIDIA NIM APIs. Handles streaming, parameter sanitization, rate-limit retries, automatic fallback, and a live token dashboard.",
    status: "Available",
    category: "ai-tools",
    featured: true,
    new: true,
    icon: "server",
    color: "#10b981",
    license: "Free · MIT License",
    tags: [
      "AI",
      "proxy",
      "Zed",
      "OpenAI",
      "free",
      "Python",
      "NVIDIA",
      "Mistral",
    ],
    badge: "Free & Open Source",
    openSource: true,
    githubUrl: "https://github.com/axiomlabssolutions/nvidia-proxy",
    priceEUR: 0,
    priceUSD: 0,
    downloadUrl: null,
    featuresTitle: "Why This Proxy Exists",
    featuresSubtitle:
      "Zed editor sends requests with extra parameters that most free AI APIs reject. This proxy handles all the compatibility issues.",
    features: [
      {
        title: "Parameter Sanitization",
        text: "Strips incompatible parameters before forwarding to providers (prompt_cache_key, stream_options, etc.)",
      },
      {
        title: "Tool Call ID Sanitization",
        text: "Fixes tool call IDs to meet Mistral's strict format requirements",
      },
      {
        title: "Automatic Retries",
        text: "Auto-retries on rate limits with exponential backoff (30s, 60s)",
      },
      {
        title: "Fallback Mechanism",
        text: "Automatically falls back to backup model when primary is throttled",
      },
      {
        title: "Token Dashboard",
        text: "Tracks token usage across all models with live RPM gauge",
      },
      {
        title: "Multi-Provider Support",
        text: "Works with NVIDIA NIM, Alibaba Model Studio, and any OpenAI-compatible API",
      },
    ],
    checkoutFeatures: [
      "Full Python proxy source code",
      "MIT License - free to use and modify",
      "Live token usage dashboard",
      "Automatic rate limit handling",
      "Multi-provider routing",
      "Community support",
    ],
  },
];

// ─── Lab Guide Metadata (client-safe) ─────────────────────
// Full guide content lives server-side in /api/lab-guide (requires auth).
// Only metadata is shipped in the JS bundle — no steps, no paragraphs, no tips.
// To add a new guide: add metadata here, add full content in functions/api/lab-guide.js

export const labGuideMeta = [
  {
    id: "phantom-vox-guide",
    title: "Getting Started with PhantomVox — Your First AI Voiceover",
    slug: "phantom-vox-guide",
    readTime: "10 min read",
    excerpt:
      "Step-by-step walkthrough from opening the notebook to downloading your first audio file. PhantomVox gives you 28 studio-quality voices across American and British accents.",
    category: "ai-tools",
    productSlug: "phantom-vox",
    tags: ["AI", "voice", "text-to-speech", "tutorial"],
    featuredImage: null,
  },
  {
    id: "dark-web-guide",
    title:
      "The Dark Web Decoded — What It Is, How It Works, and Why Privacy Matters",
    slug: "dark-web-guide",
    readTime: "12 min read",
    excerpt:
      "Separating fact from fiction — how the dark web actually works, who really uses it, and why technologies like Tor matter for anyone who takes data sovereignty seriously.",
    category: "security-tools",
    productSlug: null,
    tags: ["privacy", "Tor", "dark web", "opsec", "security"],
    featuredImage: "/assets/images/lab/dark-web-guide/hacker-mask.jpeg",
  },
  {
    id: "who-is-a-hacker",
    title: "Who Is a Hacker? — The Real Truth (Not the Hollywood Nonsense)",
    slug: "who-is-a-hacker",
    readTime: "15 min read",
    excerpt:
      "A no-BS guide to what hacking actually is, the different types of hackers (the hat system), what the job really looks like day-to-day, and how to start learning — no degree required.",
    category: "security-tools",
    productSlug: null,
    tags: [
      "hacking",
      "cybersecurity",
      "infosec",
      "ethical hacking",
      "beginners",
    ],
    featuredImage: "/assets/images/lab/who-is-a-hacker/hacker-1.jpg",
  },
  {
    id: "how-hackers-crack-passwords",
    title: "How Hackers Figure Out Passwords & Bypass Authentication",
    slug: "how-hackers-crack-passwords",
    readTime: "18 min read",
    excerpt:
      "A defensive cybersecurity research deep dive into password cracking, authentication bypass, real-world breach case studies, and how to build defenses that actually stop these attacks.",
    category: "security-tools",
    productSlug: null,
    tags: [
      "cybersecurity",
      "passwords",
      "authentication",
      "pentesting",
      "infosec",
      "research",
    ],
    featuredImage:
      "/assets/images/lab/how-hackers-crack-passwords/passwords-1.jpg",
  },
  {
    id: "phantom-vision-guide",
    title: "Getting Started with PhantomVision — Generate AI Art for Free",
    slug: "phantom-vision-guide",
    readTime: "15 min read",
    excerpt:
      "Complete walkthrough from opening the notebook to generating your first cinematic image. PhantomVision v1 runs DreamShaper XL entirely free on Google Colab.",
    category: "ai-tools",
    productSlug: "phantom-vision",
    tags: [
      "AI",
      "image generation",
      "DreamShaper XL",
      "concept art",
      "free",
      "tutorial",
    ],
    featuredImage: "/assets/images/products/phantom-vision/viking_warrior.png",
  },
  {
    id: "axiom-proxy-guide",
    title: "AxiomLabs Universal AI Proxy — Free AI for Zed Editor",
    slug: "axiom-proxy-guide",
    readTime: "10 min read",
    excerpt:
      "Step-by-step guide to setting up the AxiomLabs Universal AI Proxy to use free AI models with Zed editor. Works best with NVIDIA NIM APIs. Covers NVIDIA NIM, Alibaba Model Studio, and custom provider setup.",
    category: "ai-tools",
    productSlug: "axiom-proxy",
    tags: [
      "AI",
      "proxy",
      "Zed",
      "OpenAI",
      "NVIDIA",
      "free",
      "tutorial",
      "setup",
    ],
    featuredImage: null,
  },
];

// ─── Helpers ──────────────────────────────────────────────

export const getProductsByCategory = (catId) =>
  products.filter((p) => p.category === catId);
export const getFeaturedProducts = () => products.filter((p) => p.featured);
export const getCategoriesWithCounts = () =>
  categories.map((cat) => ({
    ...cat,
    count: products.filter((p) => p.category === cat.id).length,
  }));
export const getCategoryById = (catId) =>
  categories.find((cat) => cat.id === catId);
export const getLabGuideBySlug = (slug) =>
  labGuideMeta.find((g) => g.slug === slug);
export default products;
